module.exports = __webpack_public_path__ + "media/images/flags/ME-86c1e086e8faa92c637f429849c54551.svg";